export default __webpack_public_path__ + "static/media/advise.1bd08b83.png";